import { Col, Empty, Row } from 'antd';
import React, { useLayoutEffect, useMemo, useRef, useState } from 'react';
import CardView from '@/components/Card';
import { Card } from '@/models/card';
import { PosUIConfig } from '@/models/pos';

const containerStyle = { paddingTop: 10, paddingBottom: 100, overflow: 'hidden' };

const CardList: React.FC<{
  cardList: Card[];
  onItemClick: (card: Card) => void;
  uiConfig: PosUIConfig;
}> = ({ cardList, uiConfig, onItemClick }) => {
  const containerRef = useRef<HTMLDivElement>(null);

  if (!cardList || !cardList.length) {
    return <Empty description={'没有预付卡信息'} />;
  }

  return (
    <div style={containerStyle} ref={containerRef}>
      <Row gutter={[10, 10]}>
        {cardList.map(card => {
          return (
            <Col span={uiConfig.coSkuAreaDisplayMode === 'vertical' ? 8 : 12} key={card.id}>
              <CardView
                card={card}
                onClick={card => {
                  onItemClick(card);
                }}
              />
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export default CardList;
